// shared/infrastructure/descarga.js  (descarga de archivos binarios; devuelve { blob, nombre }, no toca el DOM)
import Api from '../../../../api/global.service';
import { DomainError } from '../domain/DomainError';
import { nombreArchivoDesdeContentDisposition, mensajeLimitePdf } from '../domain/descarga';
import { errorDesdeRespuesta } from './apiResponse';

const MENSAJE_VACIO = 'El PDF llegó vacío. Intenta de nuevo.';

const leerCabecera = (headers, nombre) => (headers ? headers[nombre] || headers[nombre.toLowerCase()] : undefined);

// Con responseType 'blob' los errores JSON del backend llegan como Blob: se leen como texto y se parsean.
const leerCuerpoError = async data => {
  if (typeof Blob === 'undefined' || !(data instanceof Blob)) return data;
  try {
    const texto = await new Response(data).text();
    return JSON.parse(texto);
  } catch (e) {
    return null;
  }
};

export const descargarArchivo = async (path, { fallbackNombre } = {}) => {
  let response;
  try {
    response = await Api.download(path);
  } catch (e) {
    if (e instanceof DomainError) throw e;
    const status = e && e.response ? e.response.status : null;
    if (status === 429) {
      throw new DomainError(mensajeLimitePdf(leerCabecera(e.response.headers, 'retry-after')), null, 429, true);
    }
    const body = await leerCuerpoError(e && e.response ? e.response.data : null);
    throw errorDesdeRespuesta(body, status);
  }
  const blob = response.data;
  if (!blob || !blob.size) throw new DomainError(MENSAJE_VACIO, null, response.status || 200, true);
  const nombre = nombreArchivoDesdeContentDisposition(leerCabecera(response.headers, 'content-disposition'), fallbackNombre);
  return { blob, nombre };
};
